import { put, takeEvery } from 'redux-saga/effects';
import { TRIGGER_INIT_SEND_MONEY_BANK_DETAILS_API } from 'redux/actionTypes';
import { apiCall } from 'services';
import { triggerInitSendMoneyBankDetailsApiCallSuccess, triggerFetchSendMoneyBankListApiCall } from 'redux/actions';
import API_CONSTANT from 'constants/apiConstant';
import { ChangeHistory, history, nativeHandler } from 'utils';

function* triggerInitSendMoneyBankDetailsApiCall(actions) {
	const { data, callback, stopLoader } = actions;
	const BANK_CODE = data['bankCode'];
	const api = yield apiCall({
		urlType: API_CONSTANT.URL_TYPE.CONSUMER,
		url: API_CONSTANT.URL.INIT_SEND_MONEY_BANK_DETAILS + API_CONSTANT.QUERY_PARAMS.BANK_CODE + BANK_CODE,
		data,
		method: 'GET',
		options: {
			dontRemoveLoader: true,
			restrictToast: true,
		},
	});
	if (api && api.data.data) {
		const apiData = api.data.data;
		if (apiData) {
			callback && callback(apiData);
			yield put(triggerInitSendMoneyBankDetailsApiCallSuccess(apiData));
		}
	} else {
		nativeHandler.removeLoader();
	}
}

export default function* triggerInitSendMoneyBankDetailsApiCallSaga() {
	yield takeEvery(TRIGGER_INIT_SEND_MONEY_BANK_DETAILS_API, triggerInitSendMoneyBankDetailsApiCall);
}
